module.exports = __webpack_public_path__ + "static/media/88.10037f79.jpg";